import React, { } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  FlatList,
  Linking,
} from "react-native";
import { timeCalulate } from "../../component/utils";
const { width, height } = Dimensions.get("window");

export default function tebleuserrank({ navigation, data, setCurrentName, onOrderPress }) {
  const [orderBy, setOrderBy] = React.useState(null);

  function handleOrderBy() {
    let newOrderBy = null;
    if (orderBy === null) {
      newOrderBy = 'asc';
    } else if (orderBy === 'asc') {
      newOrderBy = 'desc';
    } else {
      newOrderBy = null;
    }
    setOrderBy(newOrderBy);
    if (onOrderPress) {
      onOrderPress(newOrderBy);
    }
  }

  return (
    <View style={styles.back}>
      <View style={styles.head}>
        <TouchableOpacity onPress={handleOrderBy} style={[styles.viewhead, { width: width * 0.22 }]}>
          <Text style={[styles.texthead, { alignSelf: "center" }]}>User</Text>
        </TouchableOpacity>
        <View
          style={[
            styles.viewhead,
            { width: width * 0.13, justifyContent: "center" },
          ]}
        >
          <Text style={[styles.texthead, { alignSelf: "flex-start" }]}>    Date</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Time</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Distance</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Duration</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Map</Text>
        </View>
      </View>

      <FlatList
        data={data}
        scrollEnabled
        renderItem={({ index, item }) => {
          return (
            <View>
              {(
                <View style={[styles.viewmain, { backgroundColor: "#fff" }]}>
                  <TouchableOpacity
                    onPress={() => {
                      setCurrentName(item.name);
                    }}
                    style={[styles.viewdetail, { width: width * 0.22 }]}
                  >
                    <Image
                      source={{
                        uri:
                          item?.image,
                      }}
                      style={styles.img}
                    />
                    <View style={{ flexDirection: "row", width: width * 0.13, overflow: 'hidden', }}>
                      <Text style={styles.textdeil}>
                        {item.runningNumber}
                      </Text>
                      <Text style={styles.textdeil} numberOfLines={1}>
                        {item.locations.length > 0 ? `(วิ่งเอง)` : "(เขย่า)"} {item.name}
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <View style={[styles.viewdetail, { width: width * 0.13, alignItems: "center" }]}>
                    <Text
                      style={[styles.textdate, { alignSelf: "center", textAlign: "center" }]}
                      numberOfLines={1}
                    >
                      {item.date}
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {item.time} - {item.endTime}
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {(item.raw.distance / 1000).toFixed(3)} KM
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {timeCalulate(item.raw.duration)}
                    </Text>
                  </View>
                  <TouchableOpacity
                    onPress={() => {
                      if (item.start_location_lat == '0') {
                        return
                      }
                      if (item.end_location_lat == '0') {
                        return
                      }

                      // navigation.navigate("MapView", {
                      //   eventId: item.eventId,
                      //   currentName: item.name,
                      //   logId: item.id,
                      // });

                      window.open('/MapView?' + new URLSearchParams({
                        eventId: item.event_id,
                        currentName: item.name,
                        logId: item.id,
                      }).toString(), '_blank');
                    }}
                    style={[
                      styles.viewdetail,
                      {
                        width: width * 0.13,
                        height: 50,
                        justifyContent: "center",
                      },
                    ]}
                  >
                    <Text style={[styles.textdate]}>แผนที่</Text>
                  </TouchableOpacity>
                </View>
              )}
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.85,
    height: "82%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: width * 0.828,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    paddingLeft: 10,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: 15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: width * 0.828,
    height: 50,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
});
